export default {
  titulo(state) {
    return state.titulo;
  },
  itens(state) {
    return state.itens;
  },
  motivos(state) {
    return state.motivos;
  },
  produtoSilenciadoEditar(state) {
    return state.item;
  },
  produtoSilenciadoQtde(state) {
    return state.produtoSilenciadoQtde;
  }
};
